"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var CANCEL_ERROR_NAMES = ['UploadCancelledError', 'UploaderErrorCancel'];

var isUploadCancel = function isUploadCancel(error) {
  return !!error && CANCEL_ERROR_NAMES.indexOf(error.name) !== -1;
}; // `uploaderPlugin` follows the @bizzabo/components Uploader plugin contract: a factory that resolves to an
// upload function, which resolves to `{ url }` (e.g. @bizzabo/media-upload's UploaderPluginUppyS3).


var runInjectedUploader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uploaderPlugin) {
    var upload, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return uploaderPlugin();

          case 2:
            upload = _context.sent;
            _context.next = 5;
            return upload();

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result && result.url || null);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function runInjectedUploader(_x) {
    return _ref.apply(this, arguments);
  };
}();

var uploadWithInjectedPlugin = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uploaderPlugin, _ref2) {
    var onSuccess, onError, url;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onSuccess = _ref2.onSuccess, onError = _ref2.onError;
            _context2.prev = 1;
            _context2.next = 4;
            return runInjectedUploader(uploaderPlugin);

          case 4:
            url = _context2.sent;
            _context2.next = 11;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            if (!isUploadCancel(_context2.t0) && onError) onError(_context2.t0);
            return _context2.abrupt("return");

          case 11:
            if (url) onSuccess(url);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 7]]);
  }));

  return function uploadWithInjectedPlugin(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

module.exports = {
  isUploadCancel: isUploadCancel,
  runInjectedUploader: runInjectedUploader,
  uploadWithInjectedPlugin: uploadWithInjectedPlugin
};